import RestResource from '../rest.service';

export default class VisitsService extends RestResource {
  map(payload) {
    return {
      user_id: payload.userId,
      visit_date: payload.visitDate,
      details: payload.details,
      share: payload.share,
      appointment_date: payload.appointmentDate,
      participants: this.mapParticipants(payload.participants),
      visit_next_date: payload.visitNextDate,
    };
  }

  mapParticipants(participants) {
    if (participants) {
      return participants.map((p) => {
        return {
          participable_id: p.id,
          participable_type: p.type,
          principal: p.principal,
        };
      });
    }
    return [];
  }

  constructor() {
    super('visits');
  }
}
